import React from "react";
import AnimateLines from "@/components/AnimateLine";
import AdaptiveImage from "@/components/AdaptiveImage";
import EthImage from "@/components/EthImage";

import { AnimateProps } from "../../../types";
import { fomatDecimal } from "@/utils";

import "./index.css";

const Part3: React.FC<AnimateProps> = (props) => {
  const { data } = props;
  return (
    <div className="part_contain part_contain_3">
      <div style={{ flex: 1, width: "100%" }} />
      <div className="part_content">
        <AnimateLines animateType={props.type}>
          <p className="text_remind">Total Holding</p>
          <p className="mb_16">
            <span className="text_remind">Value is</span>&ensp;
            <span className="text_remind_num">
              {fomatDecimal(data.nft_value)}
            </span>
            <EthImage type="large" />
          </p>
          {
            data.nft_value > 100 ? <p className="text_content">Congrats! You are an NFT Whale 🐳!</p> : <p className="text_content">Long way to become an NFT Whale!</p>
          }
        </AnimateLines>
      </div>
      <div style={{ flex: 1, width: "100%" }} />
      <AnimateLines animateType={props.type} animateName="animate__fadeIn">
        <div>
          <AdaptiveImage name="Frame101024" />
        </div>
      </AnimateLines>
      <div style={{ flex: 2, width: "100%" }} />
    </div>
  );
};

export default Part3;
